import { ThemeProvider } from '@emotion/react';
import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { LoadingIndicator } from '@arc/frontend/ui-graphics';
import { GlobalStyles, muiTheme } from '@arc/frontend/ui-theme';
import { HubToastContainer } from '@arc/frontend/ui-toasts';
import { UserProvider } from '@arc/frontend/util-auth';
import { BatchedNavActionProvider } from '@arc/frontend/util-router';
import { WebsocketProvider } from '@arc/frontend/util-websockets';
export function Root() {
  return <>
			<ThemeProvider theme={muiTheme}>
				<HubToastContainer />
				<Suspense fallback={<LoadingIndicator />}>
					<BatchedNavActionProvider>
						<UserProvider>
							<WebsocketProvider>
								<Outlet />
							</WebsocketProvider>
						</UserProvider>
					</BatchedNavActionProvider>
				</Suspense>
			</ThemeProvider>
			<GlobalStyles />
		</>;
}